import { Card } from '@/design-system/card/card';
import { Stack } from '@/design-system/stack/stack';
import { ComponentProps } from 'react';
import { TreasuryAccountTransactionsTable } from './treasury-account-transactions-table';

export const TreasuryAccountTransactionTableWrapper = (
  props: ComponentProps<typeof TreasuryAccountTransactionsTable>,
) => {
  return (
    <Card>
      <Stack align="stretch">
        <div className="px-5 pt-5 pb-2">
          <h3 className="text-base font-medium text-foreground">Activity</h3>
        </div>

        <TreasuryAccountTransactionsTable {...props} />
      </Stack>
    </Card>
  );
};
